var LOCALE_BUNDLE = 'oskariui';
export var getMsg = function getMsg(key) {
  return Oskari.getMsg(LOCALE_BUNDLE, key);
};